import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function ServerTesting({ onClose }: ModalProps) {
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>서버 테스트 중입니다</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            현재 시스템 점검 및 테스트 중입니다. <br />
            2025.5.23.00:00 - 2025.5.23.23:59에 <br />
            진행되는 모든 예매 및 취소는 테스트 용도로, <br />
            실제 예매 및 취소로 인정되지 않습니다.
            <br />
            <br />이 기간 동안의 예매 내역은 무효 처리되오니
            <br />
            이용에 참고 부탁드립니다.
            <br />
            감사합니다.
            <br />
            <br />
          </S.Summary>
        </S.ModalContent>
        <S.CloseButton type="button" onClick={onClose}>
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
